module.exports = __webpack_public_path__ + "static/media/no-preview.7883d0e5.jpg";